import { ChannelTypes } from '@myn/shared/src/constants';

export const DISABLED_CHANNELS = [
  ChannelTypes.DIRECT,
  ChannelTypes.NETWORK,
  ChannelTypes.AD_SERVER,
  ChannelTypes.DMP,
  ChannelTypes.PUBLISHER,
  ChannelTypes.BRAND_SAFETY,
  ChannelTypes.DSP,
  ChannelTypes.WEB_ANALYTICS,
];
